import { Menu } from "../models/side-bar-menu.interface";
import { invokeCalendarLaunch } from "src/app/store/calendar/calendar.actions";
import { calendarLaunchingSelector } from "src/app/store/calendar/calendar.selectors";

export interface navBarInfoInteface {
  locationPartner: Menu[];
  advertiser: Menu[];
  admin: Menu[];
  franchise: Menu[];
}
export const NavBarInfo: navBarInfoInteface = {
  locationPartner: [
    {
      title: "sideBar.dashboard",
      icon: "home",
      type: "link",
      path: "/dashboard/location-partner/main",
      authorities: ['*'],
    },
    {
      title: "sideBar.location.promote",
      icon: "editors",
      type: "link",
      path: "/dashboard/location-partner/promote",
      authorities: ['*'],
    },
    {
      title: "sideBar.location.LPCampaigns",
      icon: "gallery",
      type: "link",
      path: "/dashboard/location-partner/LPCampaigns",
      authorities: ['*'],
    },
    {
      title: "sideBar.location.voucher",
      icon: "voucher",
      type: "link",
      path: "/dashboard/location-partner/voucher",
      authorities: ['*'],
    },
    {
      title: "sideBar.location.statistics",
      icon: "charts",
      type: "link",
      path: "/dashboard/location-partner/statistics",
      authorities: ['*'],
    },
    {
      title: "sideBar.location.remuneration",
      icon: "jobsearch",
      type: "link",
      path: "/dashboard/location-partner/remuneration",
      authorities: ['*'],
    },
    {
      title: "sideBar.support",
      icon: "ticket",
      type: "link",
      path: "/dashboard/location-partner/support",
      authorities: ['*'],
    },
  ],
  advertiser: [
    {
      title: "sideBar.dashboard",
      icon: "home",
      type: "link",
      path: "/dashboard/advertiser/main",
      authorities: ['*'],
    },
    {
      title: "sideBar.advertiser.create ad",
      icon: "editors",
      type: "link",
      path: "/dashboard/advertiser/advertising-campaigns/create-ad",
      authorities: ['*'],
    },
    {
      title: "sideBar.advertiser.insights",
      icon: "charts",
      type: "link",
      path: "/dashboard/advertiser/insights",
      authorities: ['*'],
    },
    {
      title: "sideBar.advertiser.myOrders",
      icon: "cart",
      type: "link",
      path: "/dashboard/advertiser/orders",
      authorities: ['*'],
    },
    {
      title: "sideBar.advertiser.payments",
      icon: "project",
      type: "link",
      path: "/dashboard/advertiser/payments",
      authorities: ['*'],
    },
    {
      title: "sideBar.bug report",
      icon: "ticket",
      type: "link",
      path: "/dashboard/advertiser/support",
      authorities: ['*'],
    },
  ],
  admin: [
    {
      path: "/dashboard/admin/main",
      authorities: ['*'],
      icon: "home",
      title: "sideBar.dashboard",
      type: "link",
    },
    {
      title: "sideBar.admin.advertisers.title",
      icon: "account",
      type: "sub",
      path: "/dashboard/admin/advertisers",
      authorities: ['*'],
      children: [
        {
          path: "/dashboard/admin/advertisers/repository",
          authorities: ['*'],
          title: "sideBar.admin.advertisers.repository",
          type: "link",
        },
        {
          path: "/dashboard/admin/advertisers/commandes",
          authorities: ['*'],
          title: "sideBar.admin.advertisers.orders",
          type: "link",
        },
        {
          path: "/dashboard/admin/advertisers/factures",
          authorities: ['*'],
          title: "sideBar.admin.advertisers.billings",
          type: "link",
        },
      ],
    },
    {
      path: "/dashboard/admin/location-partners",
      authorities: ['*'],
      icon: "maps",
      title: "sideBar.admin.location partners.title",
      type: "sub",
      children: [
        {
          path: "/dashboard/admin/location-partners/repository",
          authorities: ['*'],
          title: "sideBar.admin.location partners.repository",
          type: "link",
        },
        {
          path: "/dashboard/admin/location-partners/franchises",
          authorities: ['*'],
          title: "sideBar.admin.location partners.franchises",
          type: "link",
        },
        {
          path: "/dashboard/admin/location-partners/payment",
          authorities: ['*'],
          title: "sideBar.admin.location partners.payment",
          type: "link",
        },
        {
          path: "/dashboard/admin/location-partners/campagnes",
          authorities: ['*'],
          title: "sideBar.admin.location partners.campaigns",
          type: "link",
        },
      ],
    },
    {
      title: "sideBar.admin.campaigns.title",
      icon: "gallery",
      type: "sub",
      path: "/dashboard/admin/campaigns",
      authorities: ['*'],
      children: [
        {
          path: "/dashboard/admin/campaigns/pipeline",
          authorities: ['*'],
          title: "sideBar.admin.campaigns.pipeline",
          type: "link",
        },
        {
          path: "/dashboard/admin/campaigns/simulateur",
          authorities: ['*'],
          title: "sideBar.admin.campaigns.simulator",
          type: "link",
        },
        {
          path: "/dashboard/admin/campaigns/calendar",
          authorities: ['*'],
          title: "sideBar.admin.campaigns.calendar",
          type: "link",
        },
        {
          action: {
            trigger: invokeCalendarLaunch(),
            pending: calendarLaunchingSelector,
          },
          authorities: ['*'],
          title: "sideBar.admin.campaigns.calendarV2",
          type: "action",
        },
        /*{
          path: "/dashboard/admin/ads-campaigns/Codes-promos",
          authorities: ['*'],
          title: "sideBar.admin.campaigns.promos",
          type: "link",
        },*/
      ],
    },
    {
      path: "/dashboard/admin/routers",
      authorities: ['*'],
      icon: "learning",
      title: "sideBar.admin.routers.title",
      type: "sub",
      children: [
        {
          path: "/dashboard/admin/routers/relead",
          authorities: ['*'],
          title: "sideBar.admin.routers.relead",
          type: "link",
        },
        {
          path: "/dashboard/admin/routers/fsi",
          authorities: ['*'],
          title: "sideBar.admin.routers.fsi",
          type: "link",
        },
      ],
    },
    {
      path: "/dashboard/admin/consumers",
      authorities: ['*'],
      icon: "users",
      title: "sideBar.admin.consumers",
      type: "link",
    },
    {
      path: "/dashboard/admin/support",
      authorities: ['*'],
      title: "sideBar.admin.support.title",
      icon: "ticket",
      type: "sub",
      children: [
        {
          path: "/dashboard/admin/support/advertiser",
          authorities: ['*'],
          title: "sideBar.admin.support.advertisers",
          type: "link",
        },
        {
          path: "/dashboard/admin/support/lp",
          authorities: ['*'],
          title: "sideBar.admin.support.lp",
          type: "link",
        },
        {
          path: "/dashboard/admin/support/franchise",
          authorities: ['*'],
          title: "sideBar.admin.support.franchise",
          type: "link",
        }
      ],
    },
    {
      path: "/dashboard/admin/settings",
      authorities: ['*'],
      icon: "learning",
      title: "sideBar.admin.settings.title",
      type: "sub",
      children: [
        {
          path: "/dashboard/admin/settings/access-role",
          authorities: ['*'],
          title: "sideBar.admin.settings.access&Role",
          type: "link",
        },
        {
          path: "/dashboard/admin/settings/fixed-charges",
          authorities: ['*'],
          title: "sideBar.admin.settings.fixedCharges",
          type: "link",
        },
        {
          path: "/dashboard/admin/settings/promotion-codes",
          authorities: ['*'],
          title: "sideBar.admin.settings.promotionCode",
          type: "link",
        },
        {
          path: "/dashboard/admin/settings/objectives",
          authorities: ['*'],
          title: "sideBar.admin.settings.objectives",
          type: "link",
        },
        {
          path: "/dashboard/admin/settings/regions",
          authorities: ['*'],
          title: "sideBar.admin.settings.regions",
          type: "link",
        },
        {
          path: "/dashboard/admin/settings/zones",
          authorities: ['*'],
          title: "sideBar.admin.settings.zones",
          type: "link",
        },
        {
          path: "/dashboard/admin/settings/categories",
          authorities: ['*'],
          title: "sideBar.admin.settings.categories",
          type: "link",
        },
        {
          path: "/dashboard/admin/settings/sub-categories",
          authorities: ['*'],
          title: "sideBar.admin.settings.subCategories",
          type: "link",
        },
        {
          path: "/dashboard/admin/settings/tags",
          authorities: ['*'],
          title: "sideBar.admin.settings.tags",
          type: "link",
        },
        {
          path: "/dashboard/admin/settings/impressions",
          authorities: ['*'],
          title: "sideBar.admin.settings.impressions",
          type: "link",
        },
        {
          path: "/dashboard/admin/settings/prices",
          authorities: ['*'],
          title: "sideBar.admin.settings.prices",
          type: "link",
        }
      ],
    },
    {
      path: "/dashboard/admin/user-history",
      authorities: ['*'],
      icon: "page",
      title: "sideBar.admin.history",
      type: "link",
    },
    /*{
      path: "/dashboard/admin/calculator",
      authorities: ['*'],
      icon: "others",
      title: "Calculator",
      type: "link",
    },
    {
      path: "/dashboard/admin/calendar",
      authorities: ['*'],
      icon: "calender",
      title: "Calendar",
      type: "link",
    },*/
  ],
  franchise: [
    {
      title: "sideBar.franchise.dashboard",
      icon: "home",
      type: "link",
      path: "/dashboard/franchise/main",
      authorities: ['*'],
    },
    {
      title: "sideBar.franchise.promote",
      icon: "editors",
      type: "link",
      path: "/dashboard/franchise/promote",
      authorities: ['*'],
    },
    {
      path: "/dashboard/franchise/locations",
      authorities: ['*'],
      icon: "maps",
      title: "sideBar.franchise.locations.title",
      type: "sub",
      children: [
        {
          path: "/dashboard/franchise/locations/repository",
          authorities: ['*'],
          title: "sideBar.franchise.locations.repository",
          type: "link",
        },
        {
          path: "/dashboard/franchise/locations/campaigns",
          authorities: ['*'],
          title: "sideBar.franchise.locations.campaigns",
          type: "link",
        }
      ],
    },
    {
      title: "sideBar.franchise.statistics",
      icon: "charts",
      type: "link",
      path: "/dashboard/franchise/statistics",
      authorities: ['*'],
    },
    {
      title: "sideBar.franchise.remuneration",
      icon: "jobsearch",
      type: "link",
      path: "/dashboard/franchise/remuneration",
      authorities: ['*'],
    },
    {
      title: "sideBar.bug report",
      icon: "ticket",
      type: "link",
      path: "/dashboard/franchise/support",
      authorities: ['*'],
    },
  ]
};
